import * as React from 'react';
import {
    RichUtils,
    KeyBindingUtil,
    EditorState,
    ContentBlock,
    ContentState,
} from 'draft-js';


export const linkStrategy = (contentBlock: ContentBlock, callback: any, contentState: ContentState) => {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === 'LINK'
            );
        },
        callback
    );
};


export const Link = (props: any) => {
    const { contentState, entityKey } = props;
    const { url } = contentState.getEntity(entityKey).getData();
    return (
        <a
            className="link"
            href={url}
            rel="noopener noreferrer"
            target="_blank"
            aria-label={url}
        >{props.children}</a>
    );
};

const addLinkPluginPlugin = {
    customStyleMap: {
        LINK: {
            background: "yellow"
        }
    },
    keyBindingFn(event: any, other: any) {
        const { getEditorState } = other;
        const editorState = getEditorState();
        const selection = editorState.getSelection();
        // Don't do anything if no text is selected.
        if (selection.isCollapsed()) {
            return;
        }
        if (KeyBindingUtil.hasCommandModifier(event) && event.key === 'l') {
            return 'add-link'
        }
    },

    handleKeyCommand(command: string, editorState: EditorState, other: any) {
        const { setEditorState } = other;
        if (command !== 'add-link') {
            return 'not-handled';
        }
        const selection = editorState.getSelection();
        const link = window.prompt('Paste the link -')
        if (!link) {
            setEditorState(RichUtils.toggleLink(editorState, selection, null));
            return 'handled';
        }
        const content = editorState.getCurrentContent();
        const contentWithEntity = content.createEntity('LINK', 'MUTABLE', { url: link });
        const newEditorState = EditorState.push(editorState, contentWithEntity, 'apply-entity');
        const entityKey = contentWithEntity.getLastCreatedEntityKey();
        setEditorState(RichUtils.toggleLink(newEditorState, selection, entityKey))
        return 'handled';
    },

    decorators: [{
        strategy: linkStrategy,
        component: Link,
    }],
};

export default addLinkPluginPlugin;